import { abc2svg, abcNotation } from '@ezchops/abc2svg';
import React, { useMemo, useState } from 'react';
import { useClientRectSize } from '../../hooks';
/*
@deprecated
 */
export default function ABC2SVG(props) {
    const { voice, signature, unitNoteLength, sheetStyle, containerAttrs, debug } = props;
    const [element, setElement] = useState(null);
    const parent = useMemo(() => element?.parentElement ?? undefined, [element]);
    const [parentWidth,] = useClientRectSize(parent);
    const [parentColor, parentBackgroundColor] = useMemo(() => {
        if (parent) {
            const parentStyle = window.getComputedStyle(parent);
            return [
                parentStyle.getPropertyValue('color'),
                parentStyle.getPropertyValue('background-color'),
            ];
        }
        else {
            return [undefined, undefined];
        }
    }, [parent]);
    const [svg, errors] = useMemo(() => {
        const width = sheetStyle.width ?? parentWidth;
        const color = sheetStyle.color ?? parentColor;
        const background = sheetStyle.background ?? parentBackgroundColor;
        const style = { ...sheetStyle, width, color, background };
        if (debug) {
            console.debug(abcNotation(voice, signature, unitNoteLength, style));
        }
        return abc2svg(voice, signature, unitNoteLength, style);
    }, [
        sheetStyle, parentWidth, parentColor, parentBackgroundColor,
        debug, voice, signature, unitNoteLength
    ]);
    if (svg != null) {
        return React.createElement("div", { style: { width: sheetStyle.width ?? parentWidth }, ...containerAttrs, ref: setElement, dangerouslySetInnerHTML: { __html: svg ?? '' } });
    }
    if (errors != null && debug) {
        console.table(errors);
    }
    return null;
}
//# sourceMappingURL=ABC2SVG.js.map